export default {
    en: {
        tab: {
            propagate: 'On Campus_Propagate',
            general: 'On Campus_General',
            off: 'Off Campus',
        },

        list: {
            all: 'All',
            begda: 'Starting Date',
            endda: 'Ending Date',
            postx: 'Title of Office',
            remrk: 'Others',
        },

        detail: {
            period: 'Period',
            serviceDiv: 'Category',
            postx: 'Position',
            remrk: 'Note',
        },
    },
    ko: {
        tab: {
            propagate: '교내봉사(보직)',
            general: '교내봉사(봉사활동)',
            off: '교외봉사',
        },

        list: {
            all: '전체',
            begda: '시작일',
            endda: '종료일',
            postx: '보직명',
            remrk: '비고',
        },

        detail: {
            period: '기간',
            serviceDiv: '업적구분',
            postx: '직책',
            remrk: '비고',
        },
    }
}